import { Language } from '../../models/serializable/language.js';
import {
  cloneMap, DataModelBuilder, isSameData, isSameMap,
  mapToData, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { PhotoCollection } from '../../models/serializable/photo-collection.js';
import { toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class AdvertProfileComponent extends Component {
  static readonly TYPE_ID: string = 'dd0fcaf086124bbfa888fb11b1c88531';

  constructor(
    public readonly coverImages: Map<Language, PhotoCollection>,
  ) {
    super();
  }

  get $typeId() {
    return AdvertProfileComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static empty(): AdvertProfileComponent {
    return new AdvertProfileComponent(
        new Map<Language, PhotoCollection>(),
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AdvertProfileComponent {
    return new AdvertProfileComponent(
        MapUtils.getMap<Language, PhotoCollection>(map, 'coverImages', (k, v) => {
          return { key: toEnumFromString(k, Language), value: context.fromData<PhotoCollection>(v as SerializedData) };
        }),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'coverImages': mapToData(this.coverImages, (k, v) => {
        return { key: toEnumFromString(k, Language), value: context.toData(v) };
      }),
    };
  }

  clone(): this {
    return new AdvertProfileComponent(
        cloneMap(this.coverImages, (photoCollection) => photoCollection.clone()),
    ) as this;
  }

  isSame(other: AdvertProfileComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameMap(other.coverImages, this.coverImages, (left, right) => isSameData(left, right));
  }
}

export class AdvertProfileComponentBuilder extends DataModelBuilder<AdvertProfileComponent> {
  build(context: SerializationContext, map: SerializedData): AdvertProfileComponent {
    return AdvertProfileComponent.fromMap(context, map);
  }
}
